import AmazonMusic from "./AmazonMusic"
import Apple from "./Apple"
import Box from "./Box"
import Calendly from "./Calendly"
import Clubhouse from "./Clubhouse1"
import Discord from "./Discord"
import Email from "./Email"
import Etsy from "./Etsy"
import Facebook from "./Facebook"
import Github from "./Github"
import Google from "./Google"
import Instagram from "./Instagram"
import ITunes from "./ITunes1"
import Link from "./Link"
import Line from "./Line"
import LinkedIn from "./LinkedIn"
import Medium from "./Medium"
import Messenger from "./Messenger"
import Notion from "./Notion"
import Paypal from "./Paypal"
import Phone from "./Phone"
import Pinterest from "./Pinterest"
import Reddit from "./Reddit"
import ShareAndroid from "./ShareAndroid"
import ShareIOS from "./ShareIOS"
import Skype from "./Skype"
import Snapchat from "./Snapchat"
import SoundCloud from "./SoundCloud"
import Spotify from "./Spotify"
import Square from "./Square"
import StreetEasy from "./StreetEasy"
import Telegram from "./Telegram"
import Threads from "./Threads"
import TikTok from "./TikTok"
import Tumblr from "./Tumblr"
import Twitch from "./Twitch"
import Vimeo from "./Vimeo"
import Whatsapp from "./Whatsapp"
import Website from "./Website"
import X from "./X"
import Yelp from "./Yelp"
import YouTube from "./YouTube"
import YouTubeMusic from "./YouTubeMusic"
import Vemmo from "./Vemmo"
import Zillow from "./Zillow"

export default {
  AmazonMusic,
  Apple,
  Box,
  Calendly,
  Clubhouse,
  Discord,
  Email,
  Etsy,
  Facebook,
  Github,
  Google,
  Instagram,
  ITunes,
  LinkedIn,
  Link,
  Line,
  Medium,
  Messenger,
  Notion,
  Paypal,
  Phone,
  Pinterest,
  Reddit,
  ShareAndroid,
  ShareIOS,
  Skype,
  Snapchat,
  SoundCloud,
  Spotify,
  Square,
  StreetEasy,
  Telegram,
  Threads,
  TikTok,
  Tumblr,
  Twitch,
  Vimeo,
  Whatsapp,
  Website,
  X,
  Yelp,
  YouTube,
  YouTubeMusic,
  Vemmo,
  Zillow,
}
